// extracted by mini-css-extract-plugin
export default {"button":"styles_button__9emP-","disabled":"styles_disabled__+Ax2J","loading":"styles_loading__yMDLG","spinner":"styles_spinner__XW1fV","spin":"styles_spin__eFi0G"};